export default __webpack_public_path__ + "feature36adedc.png";